import React from 'react';
import PropTypes from 'prop-types';
import { hr_consulting_img } from 'assets/images';
import { Button } from 'components/widgets/buttons';

function HrConsultation({ children }) {
  const [HeroSection, ...Donate] = children;
  return (
    <>
      <div className="w-full">{HeroSection}</div>

      <div className="flex flex-col bg-white items-center justify-center md:px-20 lg:px-40 px-8 py-16">
        <div className="flex flex-col items-center justify-center mx-2">
          <h3 className="w-full text-gold font-semibold text-center md:justify-center text-3xl  md:text-5xl py-5 ">
            <span className="hidden md:inline">Requirements for </span> HR Consulting
          </h3>
          <div className="md:hidden">
            <figure className="w-full h-98">
              <img src={hr_consulting_img} className=" rounded-xl md:hidden" />
            </figure>
          </div>
          <div className=" text-justify">
            <div className="text-main font-normal text-base md:text-2xl py-2 md:inline mr-1">
              <h3 className="font-bold">Scope of Work:</h3>
              <p>
                We will provide comprehensive HR services to your company. That will include, but
                not be limited to, the following areas:
              </p>

              <ul className="list-disc text-main font-normal text-base md:text-2xl py-2 md:inline mr-1 flex flex-col gap-2 ml-2 md:ml-4">
                <li>Recruitment and selection</li>
                <li>Employee relations</li>
                <li>Performance management</li>
                <li>Compensation and benefits</li>
                <li>Training and development</li>
                <li>HR policy and procedure development</li>
              </ul>

              <h3 className="font-bold">Our expected deliverables are:</h3>

              <ul className="list-disc text-main font-normal text-base md:text-2xl py-2 md:inline mr-1 flex flex-col gap-2 ml-2 md:ml-4">
                <li>
                  Develop and implement a comprehensive recruitment strategy that attracts and
                  retains top talent for your company.
                </li>
                <li>
                  Provide guidance and support to managers on all employee relations issues,
                  including conflict resolution, disciplinary actions, and termination.
                </li>
                <li>
                  Design and implement a performance management program that aligns with your
                  companys goals and objectives.
                </li>
                <li>
                  Conduct a comprehensive review of your current compensation and benefits packages
                  and provide recommendations for improvement.
                </li>
                <li>
                  Develop and deliver training programs to enhance employee skills and knowledge,
                  including orientation, leadership development, and technical training.
                </li>
                <li>
                  Develop and implement HR policies and procedures compliant with local, state, and
                  federal laws and regulations.
                </li>
              </ul>

              <h3 className="font-bold">Timeline: </h3>
              <p>Both parties will mutually agree upon the timeline for each deliverable.</p>

              <h3>Key Performance Indicators:</h3>
              <p>The following KPIs will be used to measure the success of our services:</p>

              <ul className="list-disc text-main font-normal text-base md:text-2xl py-2 md:inline mr-1 flex flex-col  gap-2 pl-2 md:pl-20">
                <li>Time to fill vacancies</li>
                <li>Employee turnover rate</li>
                <li>Employee satisfaction survey results</li>
                <li>Compliance with local, state, and federal laws and regulations</li>
                <li>Quality and effectiveness of training programs</li>
                <li>Feedback from managers and employees on HR policies and procedures</li>
              </ul>

              <h3 className="font-bold">Fees: </h3>
              <p>
                The fee structure will be determined and agreed upon by both parties before the
                start of the engagement. Any additional expenses incurred by us in the course of
                providing services will be pre-approved by your company.
              </p>
            </div>
          </div>

          <Button className="my-10 btn w-[250px] h-[32px] md:w-[512px] md:h-[54px] normal-case text-gold border border-gold bg-white hover:bg-gold hover:text-white hover:border-gold">
            <span className="md:hidden">Enroll Now</span>
            <span className="hidden md:block">Get A Free Consultation</span>
          </Button>
        </div>
      </div>

      <div className="flex flex-col bg-white items-center justify-center md:px-20 lg:px-40 px-8 py-16">
        <div className="flex flex-col items-center justify-center mx-2">
          <h3 className="w-full text-gold font-semibold text-center md:justify-center text-3xl  md:text-5xl py-5 ">
            <span className="hidden md:inline">Requirements for </span> Product Design
          </h3>
          <div className="md:hidden">
            <figure className="w-full h-98">
              <img src={hr_consulting_img} className=" rounded-xl md:hidden" />
            </figure>
          </div>
          <div className=" text-justify text-main font-normal text-base md:text-2xl">
            <h3 className="font-bold py-4">Scope of work and deliverables:</h3>
            <ul className="list-disc text-main font-normal text-base md:text-2xl py-2 md:inline mr-1 flex flex-col  gap-2 pl-2 md:pl-20">
              <li>
                <span className="font-bold">Product Design:</span> We will provide end-to-end
                product design services, including research, ideation, prototyping, and testing.
              </li>
              <li>
                <span className="font-bold">User Experience Design:</span> We will prioritize user
                experience and provide intuitive, user-friendly designs that meet the target
                audiences needs.
              </li>
              <li>
                <span className="font-bold">Industrial Design:</span> We will provide industrial
                design services, including designing the products form, function, and materials.
              </li>
              <li>
                <span className="font-bold">Design and Manufacturing:</span> We will ensure that the
                design is optimized for manufacturing, with consideration for cost, scalability, and
                quality.
              </li>
              <li>
                <span className="font-bold">Design and Strategy:</span> We will provide a
                comprehensive design strategy for the client, including guidance on branding,
                marketing, and other aspects of your products lifecycle.
              </li>
            </ul>
          </div>

          <Button className="my-10 btn w-[250px] h-[32px] md:w-[512px] md:h-[54px] normal-case text-gold border border-gold bg-white hover:bg-gold hover:text-white hover:border-gold">
            <span className="md:hidden">Enroll Now</span>
            <span className="hidden md:block">Get A Free Consultation</span>
          </Button>
        </div>
      </div>

      <div className="flex flex-col bg-white items-center justify-center md:px-20 lg:px-40 px-8 py-16">
        <div className="flex flex-col items-center justify-center mx-2">
          <h3 className="w-full text-gold font-semibold text-center md:justify-center text-3xl  md:text-5xl py-5 ">
            <span className="hidden md:inline">Requirements for </span> Software Development:
          </h3>
          <div className="md:hidden">
            <figure className="w-full h-98">
              <img src={hr_consulting_img} className=" rounded-xl md:hidden" />
            </figure>
          </div>
          <div className=" text-justify">
            <div className="text-main font-normal text-base md:text-2xl py-2 md:inline mr-1">
              <h3 className="font-bold py-4">Scope of Work and Deliverables:</h3>

              <ul className="list-disc text-main font-normal text-base md:text-2xl py-2 md:inline mr-1 flex flex-col gap-2 ml-2 md:ml-4">
                <li>
                  <span className="font-bold">Software Development:</span> We will provide
                  end-to-end software development services, including requirements gathering,
                  design, development, testing, and deployment.
                </li>
                <li>
                  <span className="font-bold">Technology Consulting:</span> We will give expert
                  guidance on technology choices, platform selection, and other technical decisions.
                </li>
                <li>
                  <span className="font-bold">Project Management:</span> We will provide project
                  management services, ensuring that projects are delivered on time, within budget,
                  and to the client`&apos;`s satisfaction.
                </li>
                <li>
                  <span className="font-bold">Maintenance and Support: </span>
                  We will provide ongoing maintenance and support services to ensure that your
                  software remains functional and up-to-date.
                </li>
                <li>
                  <span className="font-bold">Quality Assurance: </span> We will provide a rigorous
                  quality assurance process to ensure that your software meets all requirements and
                  is bug-free.
                </li>
              </ul>

              <h3 className="font-bold">Timeline: </h3>
              <p>Both parties will mutually agree upon the timeline for each deliverable.</p>

              <h3 className="font-bold">Fees: </h3>
              <p>
                The fee structure will be determined and agreed upon by both parties before the
                start of the engagement. Any additional expenses incurred by us in the course of
                providing services will be pre-approved by your company.
              </p>
            </div>
          </div>

          <Button className="my-10 btn w-[250px] h-[32px] md:w-[512px] md:h-[54px] normal-case text-gold border border-gold bg-white hover:bg-gold hover:text-white hover:border-gold">
            <span className="md:hidden">Enroll Now</span>
            <span className="hidden md:block">Get A Free Consultation</span>
          </Button>
        </div>
      </div>

      <div className="flex flex-col bg-white items-center justify-center md:px-20 lg:px-40 px-8 py-16">
        <div className="flex flex-col items-center justify-center mx-2">
          <h3 className="w-full text-gold font-semibold text-center md:justify-center text-3xl  md:text-5xl py-5 ">
            <span className="hidden md:inline">Requirements for </span> Branding
          </h3>
          <div className="md:hidden">
            <figure className="w-full h-98">
              <img src={hr_consulting_img} className=" rounded-xl md:hidden" />
            </figure>
          </div>
          <div className=" text-justify">
            <div className="text-main font-normal text-base md:text-2xl py-2 md:inline mr-1">
              <h3 className="font-bold py-4">Scope of Work and Deliverables:</h3>

              <ul className="list-disc text-main font-normal text-base md:text-2xl py-2 md:inline mr-1 flex flex-col gap-2 ml-2 md:ml-4">
                <li>
                  <span className="font-bold">Brand Strategy:</span> We will a comprehensive brand
                  strategy for your business, which includes defining the target audience, brand
                  personality, key messaging, and value proposition.
                </li>
                <li>
                  <span className="font-bold">Brand Identity:</span> We will create a visual
                  identity system for your brand. That will including the logo, color scheme,
                  typography, and other graphic elements.
                </li>
                <li>
                  <span className="font-bold">Brand Guidelines:</span> We will provide guidelines
                  for the brand that ensure consistency across all touchpoints, including print and
                  digital media, advertising, and packaging.
                </li>
                <li>
                  <span className="font-bold">Brand Experience: </span>
                  We design a cohesive customer experience, ensuring that all touchpoints reflect
                  your brand’s values and personality.
                </li>
                <li>
                  <span className="font-bold">Brand Monitoring: </span> We will monitor your brand’s
                  reputation and provide ongoing support to ensure your brand stays true to its
                  vision and goals.
                </li>
              </ul>

              <h3 className="font-bold">Timeline: </h3>
              <p>Both parties will mutually agree upon the timeline for each deliverable.</p>

              <h3 className="font-bold">Fees: </h3>
              <p>
                The fee structure will be determined and agreed upon by both parties before the
                start of the engagement. Any additional expenses incurred by us in the course of
                providing services will be pre-approved by your company.
              </p>
            </div>
          </div>

          <Button className="my-10 btn w-[250px] h-[32px] md:w-[512px] md:h-[54px] normal-case text-gold border border-gold bg-white hover:bg-gold hover:text-white hover:border-gold">
            <span className="md:hidden">Enroll Now</span>
            <span className="hidden md:block">Get A Free Consultation</span>
          </Button>
        </div>
      </div>

      <div className="w-full">{Donate}</div>
    </>
  );
}

HrConsultation.propTypes = {
  children: PropTypes.any
};

export default HrConsultation;
